var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelWordpress14 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "#FF3CA0",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FCFDFD",
  d: "M7 2c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5m.079 5.393-1.349 3.92a4.5 4.5 0 0 0 2.763-.072.4.4 0 0 1-.032-.062zM2.894 5.17a4.496 4.496 0 0 0 2.144 5.875Zm8.05-.327q.03.214.03.463c0 .456-.084.968-.34 1.61l-1.374 3.97a4.493 4.493 0 0 0 1.685-6.043M7 2.505A4.49 4.49 0 0 0 3.244 4.53q.16.005.29.005c.47 0 1.197-.057 1.197-.057.243-.014.271.342.03.37 0 0-.244.029-.515.043l1.637 4.87.984-2.95-.7-1.92c-.243-.014-.472-.043-.472-.043-.243-.014-.214-.384.028-.37l.106.008.164.01c.257.018.642.04.914.04.47 0 1.198-.058 1.198-.058.243-.014.271.342.029.37 0 0-.244.029-.514.043l1.624 4.833.449-1.499c.194-.622.342-1.068.342-1.453 0-.556-.2-.94-.37-1.24-.229-.37-.443-.684-.443-1.054 0-.413.314-.798.755-.798q.03.001.059.004A4.48 4.48 0 0 0 7 2.505"
}))));
export default SvgChannelWordpress14;